export const useStorage = () => {
	const saveInStorage = (keyStorage: string, formData: any): void => {
		let localFormData = JSON.parse(getFromStorage(keyStorage) || '{}');
		localFormData = { ...localFormData, ...formData };
		sessionStorage.setItem(keyStorage, JSON.stringify(localFormData));
	};

	const getFromStorage = (keyStorage: string): string | null => {
		return sessionStorage.getItem(keyStorage);
	};

	const getItemFromStorage = (keyStorage: string, keyObject: string): any => {
		let localFormData = JSON.parse(getFromStorage(keyStorage) || '{}');
		return localFormData[keyObject];
	};

	const deleteItemFromStorage = (keyStorage: string, keyObject: string): void => {
		let localFormData = JSON.parse(getFromStorage(keyStorage) || '{}');
		delete localFormData[keyObject];
		sessionStorage.setItem(keyStorage, JSON.stringify(localFormData));
	};

	return { saveInStorage, getFromStorage, getItemFromStorage, deleteItemFromStorage } as const;
};
